import React, { useState, useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { isDeviceTokenExists } from '@nbx/frontend-helpers/auth';
import { useAuthSession } from '@nbx/frontend-helpers/subscribe';
import { Redirect } from 'react-router-dom';
import { Login } from './Login';

const microapps = window.MICROFRONTENDS_CONFIG;

interface LoginWrapProps {
  dispatch: () => void;
  error: string;
  loading: boolean;
  step: string;
  isMobile: boolean;
}

export const LoginWrap = (props: LoginWrapProps) => {
  const [state, setState] = useState<{ isDeviceTokenExists?: boolean; isLoading: boolean }>({
    isLoading: true
  });

  const session = useAuthSession();

  useEffect(() => {
    if (session === undefined) return;
    if (Capacitor.isNativePlatform()) {
      (async () => {
        if ((await isDeviceTokenExists()) && session === null) {
          setState(state => ({ ...state, isDeviceTokenExists: true }));
        } else {
          setState(state => ({ ...state, isDeviceTokenExists: false }));
        }
      })()
        .catch(console.error)
        .finally(() => {
          setState(state => ({ ...state, isLoading: false }));
        });
    }
  }, [session]);

  if (!Capacitor.isNativePlatform()) return <Login {...props} />;
  else if (state.isLoading) return <nbx-text>loading...</nbx-text>;
  else if (!state.isDeviceTokenExists) return <Login {...props} />;
  else
    return (
      <Redirect
        to={{ pathname: microapps.routes.mobileSessionExpired.path, state: { from: props.location } }}
      />
    );
};
